module.exports = __webpack_public_path__ + "media/images/pic/teachers/julia-caba-7eb14d42c2b9831e003c17d111b8c2da.png";